import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import { useAuthStore } from './stores/auth';

import './styles/tokens.css';
import './styles/base.css';
import './styles/components.css';

const app = createApp(App);
app.use(createPinia());

// Start listening for Firebase auth state before mounting so router guards
// resolve cleanly on first paint.
useAuthStore().init();

app.use(router);
app.mount('#app');
